module.exports = __webpack_public_path__ + "img/home-faq-teaser-man-ipad.fd5783d.jpg";